import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { NbDialogRef, NbDialogService, NbToastrService, NbCardModule, NbIconModule, NbButtonModule, NbCheckboxModule, NbTooltipModule, NbInputModule } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { Observable, Subject, takeUntil } from 'rxjs';
import { RouterState } from 'src/app/features/auth/redux';
import { Insight } from 'src/app/models/insight';
import { STATUSES } from 'src/app/shared/constants/general-constants';
import { ViewCampaignComponent } from '../../../campaigns/campaign-table/view-campaign/view-campaign.component';
import { CampaignState, DeepDeleteCampaign, LoadAffectedCampaignsByInsight } from '../../../campaigns/redux';
import { DeleteInsights } from '../../redux';
import { NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-delete-insight',
    templateUrl: './delete-insight.component.html',
    styleUrls: ['./delete-insight.component.css'],
    imports: [NbCardModule, NbIconModule, NbButtonModule, NgIf, FormsModule, NgFor, NbCheckboxModule, NbTooltipModule, NbInputModule]
})
export class DeleteInsightComponent implements OnInit, OnDestroy {
  public affectedCampaign$: Observable<any> = inject(Store).select(CampaignState.affectedCampaigns);
  public spin$: Observable<boolean> = inject(Store).select(CampaignState.spin);
  public username$: Observable<string> = inject(Store).select(RouterState.username);
  private unsubscribe: Subject<void> = new Subject();

  public spin;
  public insight;
  public confirmation = '';
  public affectedCampaigns = [];
  public activeCampaigns = [];
  public selectedCampaigns = [];
  public checked = [];
  public username = '';
  constructor(
    protected ref: NbDialogRef<DeleteInsightComponent>,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
    private store: Store
  ) {}

  public ngOnInit(): void {
    this.affectedCampaign$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => {
      if (data.campaigns) {
        this.activeCampaigns = data.campaigns.filter(
          (campaign) => campaign.status === STATUSES.ACTIVE || campaign.status === STATUSES.RUNNING
        );
      }

      return (this.affectedCampaigns = data.campaigns);
    });
    this.username$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.username = data));

    this.store.dispatch(new LoadAffectedCampaignsByInsight(this.insight));
    this.spin$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.spin = data));
  }

  public ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public close(): void {
    this.ref.close();
  }
  public deepDelete(): void {
    for (const campaign of this.selectedCampaigns) {
      const payload = {
        campaign_id: campaign.id,
        deleted_by: this.username
      };
      this.store.dispatch(new DeepDeleteCampaign(payload));
    }

    const insightToDelete = Insight.copy(this.insight);
    insightToDelete.deleted = true;
    this.store.dispatch(new DeleteInsights(insightToDelete));

    this.ref.close();
  }

  public checkedChange(item, event): void {
    if (event) {
      this.selectedCampaigns.push(item);
    } else {
      this.selectedCampaigns = this.selectedCampaigns.filter((campaign) => campaign.id !== item.id);
    }
  }

  public viewCampaign(event): void {
    const found = this.affectedCampaigns.find((element) => element.id === event);
    if (found) {
      this.dialogService
        .open(ViewCampaignComponent, {
          closeOnEsc: false,
          closeOnBackdropClick: false,
          context: {
            campaign: found
          }
        })
        .onClose.subscribe((d) => {
          this.store.dispatch(new LoadAffectedCampaignsByInsight(this.insight));
        });
    } else {
      this.toastrService.show(status, $localize`Campaign with this ID does not exist`, {
        status: 'danger'
      });
    }
  }
}
